<template>
  <transition name="fade"
              @enter="enter"
              @leave="leave"
              @enter-cancelled="enterCancelled"
              @leave-cancelled="leaveCancelled"
              @after-leave="complete"
              @after-enter="complete">
    <slot />
  </transition>
</template>


<script>
import { TweenMax, TimelineMax } from 'gsap';
import { isNil } from 'lodash';

export default {
  name: 'TransitionFade',
  css: false,


  props: {
    duration: {
      required: false,
      default: 0.25,
    },
  },

  methods: {
    enter: function (el, done) {
      if (this.tl) {
        this.tl.play();
      } else {
        this.tl = new TimelineMax({
          onComplete: done,
          onReverseComplete: done,
        });
        this.tl.add(TweenMax.fromTo(el, this.duration, { opacity: 0 }, { opacity: 1 }));
      }
    },
    enterCancelled: function (el) {
    },
    leave: function (el, done) {
      if (isNil(this.tl) && !isNil(el)) {
        el.style.opacity = '1.0';
        done();
      } else {
        this.tl.eventCallback('onReverseComplete', done);
        this.tl.reverse();
      }
    },
    leaveCancelled: function (el) {
    },
    complete: function () {
      this.$emit('complete');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/transitions/TransitionFade.vue